import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import TimeAgo from '../TimeAgo'

function RecentPosts({ posts }) {
  return (
    <div className="et_pb_widget rpwe_widget recent-posts-extended">
      <h4 className="widgettitle">Recent Posts</h4>
      <div className="rpwe-block">
        <ul className="rpwe-ul">
          {posts.map((post) => (
            <li key={post.id} className="rpwe-li rpwe-clearfix">
              <h3 className="rpwe-title">
                <Link to={`/${post.slug}`} title={post.title} rel="bookmark">
                  {post.title}
                </Link>
              </h3>
              <TimeAgo
                className="rpwe-time published"
                dateTime={post.published_at}
              />
              <div className="rpwe-summary">
                {post.excerpt} <Link to={`/${post.slug}`}>Read More »</Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

RecentPosts.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      published_at: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
    }),
  ).isRequired,
}

export default RecentPosts
